import React from 'react'

const RefundPolicy = () => {
    return (
        <div>
            <h1>Политика возврата и отмены</h1>
            <p>Мы понимаем, что в жизни могут произойти непредвиденные обстоятельства. Ниже описаны правила возврата денежных средств при отмене заказанных услуг.</p>
            <h3>1. Отмена и возврат</h3>
            <ul>
                <li>
                    <p>При отмене тура за <strong>30 дней и более</strong> до вылета &mdash; возврат 100%</p>
                </li>
                <li>
                    <p>За <strong>14&ndash;29 дней</strong> &mdash; возврат 70%</p>
                </li>
                <li>
                    <p>За <strong>7&ndash;13 дней</strong> &mdash; возврат 50%</p>
                </li>
                <li>
                    <p>Менее чем за <strong>7 дней</strong> &mdash; возврат не осуществляется, так как все расходы уже понесены</p>
                </li>
            </ul>
            <h3>2. Способ возврата</h3>
            <p>Возврат осуществляется на ту же карту или счёт, с которого была произведена оплата.</p>
            <h3>3. Срок возврата</h3>
            <p>Срок возврата денежных средств &mdash; до <strong>10 рабочих дней</strong> с момента подтверждения отмены.</p>
            <h3>4. Как отменить</h3>
            <p>Вы можете подать запрос на отмену, связавшись с нами:
                <br />📧 Email: <a href="mailto:info@hajjtravel.kz">info@hajjtravel.kz</a>
                <br />📞 Телефон: <a href="tel:+77054083130">+7 (705)408 31 30</a></p>
        </div>
    )
}

export default RefundPolicy;